import { divIcon, LatLngExpression } from 'leaflet'
import React from 'react'
import { MapContainer, Marker, Polyline, Popup, TileLayer, useMap } from 'react-leaflet'
// import {
//     MapContainer,
//     TileLayer,
//     useMap,
//   } from 'https://cdn.esm.sh/react-leaflet'
type Props = {}

interface stopExceptionInfo {
    description: string,
    color: string

}
const LeafletMap = (props: any) => {

    console.log("cities from Leaflet: ", props.cities)
    const getStopIcon = (stopInfo: stopExceptionInfo) => {
        const color = stopInfo.color
        return (
            divIcon({
                className: 'custom-div-icon',
                html: `<div style="background-color: ${color}; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white;"></div>`,
                iconSize: [12, 12],
                iconAnchor: [6, 6]
            })
        )
    }
    // const center: any = [40.7128, -74.00060]
    let points: LatLngExpression[] = []
    props.cities.map((stops: any) => points.push(stops.position.reverse()))
    // const center: any = points[0] !== null ? points[0] : [40.7128, -74.00060]
    const offsetAmount = 500;
    const positionCounts = {};
    const positionIndices = {};
    // const center: any = [40.7128, -74.00060]
    const center: any = points[0] !== null ? points[0] : [40.7128, -74.00060]
    console.log("points: ", points)




    return (
        <div style={{ height: '2rem' }}>
            {/* <MapContainer center={[51.505, -0.09]} zoom={13} style={{ height: "60vh" }}> */}
            <MapContainer
                center={center}
                zoom={12}
                style={{ height: "30vh" }}
            >
                <TileLayer
                    url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {/* Route Line */}
                <Polyline
                    positions={points}
                    color='blue'
                    weight={3}
                    opacity={0.6}
                />
                {props.cities.map((stop: any, idx: number) => stop.position && (
                    <Marker
                        key={idx}
                        position={stop.position}
                        icon={getStopIcon(stop.stopTopException)}
                    >
                        <Popup>
                            <div className="text-sm">
                                <p className="font-semibold">{stop.description}</p>
                                <p className="text-gray-600">{stop.addressName.replace('<br />', '\n')}</p>
                                {/* <p className="text-gray-500 mt-1">
                                    {stop.estimatedTime} - {stop.status}
                                </p> */}
                            </div>
                        </Popup>

                    </Marker>
                ))}
            </MapContainer>
        </div>
    )
}

export default LeafletMap